// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"e4cb187d","617":"0a252a12"}[chunkId] + ".chunk.css";
};